/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
} from '@msdyn365-commerce/core';
import { getOrderAsync } from '../../../data-actions/generated/DataActionExtension.g';
import { IDXC_GetOrderResponse } from '../../../data-actions/generated/DataServiceEntities.g';

/**
 * AfterpayGetOrderDataAction Input Action
 */

export class AfterpayGetOrderDataActionInput implements IActionInput {
    public token: string;

    // Construct the input needed to run the action
    constructor(token: string) {
        this.token = token;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `AfterpayGetOrder ${this.token}`;
    public getCacheObjectType = () => 'AfterpayGetOrder';
    public dataCacheType = (): CacheType => 'request';
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: AfterpayGetOrderDataActionInput): IActionInput => {
    return args;
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function getAfterpayOrderAction(
    input:AfterpayGetOrderDataActionInput,
    ctx: IActionContext
):Promise<IDXC_GetOrderResponse> {
    // Input only needs token
    const result: IDXC_GetOrderResponse = await getOrderAsync({ callerContext: ctx }, input.token);

    return Array.isArray(result) ? result[0] : result;
}

export const IAfterpayGetOrderDataActionAction =  createObservableDataAction({
    action: <IAction<IDXC_GetOrderResponse>>getAfterpayOrderAction,
    input: createInput
});
